const modes: Record<string, { label: string; value: string }[]> = {
  hip_joint: [
    {
      label: "Выберите режим",
      value: "",
    },
    {
      label: "T1",
      value: "T1",
    },
    {
      label: "T2",
      value: "T2",
    },
    {
      label: "PD",
      value: "PD",
    },
    {
      label: "T1 FS",
      value: "T1 FS",
    },
    {
      label: "T2 FS",
      value: "T2 FS",
    },
    {
      label: "PD Stir",
      value: "PD Stir",
    },
  ],
};

export default modes;
